import { useState } from "react";
import { ReactComponent as BaseCorp } from "../../assets/icons/companylogo.svg";
import { ReactComponent as SubMenuIcon } from "../../assets/icons/sideBarIcon.svg";
import sidemenucss from "../../css/sidemenu.module.css";
import { useHistory } from "react-router-dom";

const ReceivablesSideBar = ({
  activeTab,
  subMenuItem,
  id,
  companyId,
  companyName,
  regName,
}) => {
  // const redirectTo = (link) => {
  //   window.location.href = link;
  // };

  const routerHistory = useHistory();
  const handleClick = (Link) => {
  routerHistory.push(Link, {
    companyName,
    regName,
  });
};


  const subMenu = () => {
    if (hideUnHideSubMenu === "A") {
      sethideUnHideSubMenu("I");
    } else {
      sethideUnHideSubMenu("A");
    }
  };

  const [hideUnHideSubMenu, sethideUnHideSubMenu] = useState("A");

  const menuItems = [
    {
      key: 2,
      label: "Receivables Listing",
      pagelink: `/myfinV2/receivables/listing/${id}/${companyId}`,
    },
    {
      key: 3,
      label: "Compute Calculations",
      subMenu: [
        { label: "ECL", link: `/myfinV2/receivables/ecl/${id}/${companyId}` },
      ],
    },
  ];

  const activeItem = activeTab;
  const activeItemSubMenu = subMenuItem;

  return (
    <div
      className={`${sidemenucss.sidemenuContainer} ${sidemenucss.sidemenuBackgroundClr}`}
    >
      <div className={sidemenucss.sidemenuHeader}>
        <BaseCorp className={sidemenucss.sidemenuCompanyLogoSize} />
        <div className={sidemenucss.sidemenuTitleContainer}>
          <div className={sidemenucss.sidemenuTitle}>
            {regName ? regName : "Receivables Register"}
          </div>
          {companyName && (
            <span className={sidemenucss.sidemenuSubtitle}>
              {companyName || "Company Name"}
            </span>
          )}
        </div>
      </div>
      <div
        className={`${sidemenucss.sidemenuContent} ${sidemenucss.sidemenuLinksFontSize} ${sidemenucss.sidemenuContentTop}`}
      >
        <ul className={sidemenucss.sidemenuList}>
          {menuItems.map((item, index) => (
            <div key={index}>
              <li
                onClick={() => {
                  subMenu();
                  if (item.pagelink) {
                    setTimeout(() => {
                      routerHistory.push(item.pagelink, {
                        companyName: companyName,
                        regName: regName,
                      });
                      sessionStorage.setItem("companyName", companyName);
                      sessionStorage.setItem("regName", regName);
                    }, 100);
                  }
                }}
                className={`${sidemenucss.sidemenuItem} ${
                  activeItem === item.label
                    ? sidemenucss.sidemenuItemActive
                    : ""
                }`}
              >
                <span className={sidemenucss.sidemenuItemname}>
                  <div className={sidemenucss.sideMenuItemContainer}>
                    {item.label}
                    <div className={sidemenucss.submenuIcon}>
                      {item.subMenu ? (
                        <SubMenuIcon
                          className={`${sidemenucss.submenuIconSvg} ${
                            hideUnHideSubMenu === "A"
                              ? null
                              : sidemenucss.rotatedIcon
                          }`}
                        />
                      ) : null}
                    </div>
                  </div>
                </span>
              </li>
              {item.subMenu ? (
                <div
                  className={`${sidemenucss.submenuContainer} ${
                    hideUnHideSubMenu === "A"
                      ? sidemenucss.sideMenuShow
                      : sidemenucss.sideMenuHide
                  }`}
                >
                  {item.subMenu.map((sub, idx) => (
                    <div
                      key={idx}
                      className={`${sidemenucss.submenuItem} ${
                        activeItemSubMenu === sub.label
                          ? sidemenucss.activeSubMenu
                          : null
                      }`}
                      onClick={() => handleClick(sub.link)}
                    >
                      {sub.label}
                    </div>
                  ))}
                </div>
              ) : null}
            </div>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ReceivablesSideBar;
